import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-patient-remain-modal',
  templateUrl: './patient-remain-modal.component.html',
  styleUrl: './patient-remain-modal.component.scss'
})
export class PatientRemainModalComponent implements OnInit {
  // Define properties and methods as needed for the patient remain modal

  constructor(
    public dialogRef: MatDialogRef<PatientRemainModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
  }

   closeModal(value?: string): void {
    if (value) {
      this.dialogRef.close({ success: true, val: value });
    } else {
      this.dialogRef.close({ success: false, val: value });
    }
  }


}
